import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface ArYodaRulesAddedCancelNotifyFollowersProps extends BaseTemplateProps {
  request: {
    name: string
  }
}

export const ArYodaRulesAddedCancelNotifyFollowers: TemplateDefinition<ArYodaRulesAddedCancelNotifyFollowersProps> =
  {
    renderParams: (props: ArYodaRulesAddedCancelNotifyFollowersProps) => ({
      messageKey: 'notificationsDomain.templates.arYodaRulesAddedCancelNotifyFollowers',
      values: {
        ruleName: props?.request?.name,
      },
    }),
  }
